import {HttpHandler} from "../../../utils/handler/HttpHandler";

export class BilateralCatalogService {
    constructor(){
        this.httpHandler = new HttpHandler();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral');
    }
    getCatalogInstitutions(institutionType) {
        return this.axiosInstance({
            url: '/catalog/institutions',
            method: 'get',
            params: {
                institutionType: institutionType
            }
        }).then(res => res);
    }

    getCatalogFlow() {
        return this.axiosInstance({
            url: '/catalog/flow',
            method: 'get',
        }).then(res => res);
    }

    getCollateralToAssign(loanId) {
        return this.axiosInstance({
            url: '/catalog/' + loanId + '/collateral/assign',
            method: 'get',
        }).then(res => res);
    }

}